
import ReactDOM from 'react-dom/client';
import { HashRouter, } from 'react-router-dom'

import 'index.css';

import reportWebVitals from 'reportWebVitals';
import { Root } from 'pages/Root.js'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <Root />
  </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
